import React from 'react';
import Container from 'components/UI/Container';
import Image from 'components/UI/Image';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';

import * as styles from './StaticLayout.module.scss';

export default function StaticLayout({ imgSections }) {
  return (
    <Container padding="Without">
      {imgSections?.map(({ img, titles, descriptions }, i) => (
        <div key={i} className={styles.section}>
          <Image src={img} className={styles.picture} classImage={styles.img} />
          <div className={styles.hiddenContent}>
            {titles?.map(title => (
              <Title key={title} tag="h3">
                {title}
              </Title>
            ))}
            {descriptions?.map(description => (
              <Subtitle key={description}>{description}</Subtitle>
            ))}
          </div>
        </div>
      ))}
    </Container>
  );
}
